import { useTracker } from '../lib/useTracker';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useScreen } from '../lib/useScreen';
import { useTheme } from '../lib/useTheme';
import { startCheckout } from '../lib/checkout';
import { useAuth } from '../lib/AuthProvider';
// FlipCarousel, MOMENTUM_ACTIVO, AnimatedCounter — removed with old memberships section
// import JourneyStepper from '../lib/JourneyStepper'; // Desactivado — sección "Tu camino" removida temporalmente
import { ParticlesCanvas, Bar, Card } from '../components/landing';
import HeroArbol from '../components/landing/HeroArbol';
import Ritual4 from '../components/landing/Ritual4';
import Pasos5 from '../components/landing/Pasos5';
import SeccionArbol from '../components/landing/SeccionArbol';
import SeccionProyectos from '../components/landing/SeccionProyectos';
import ComunidadFloat from '../components/landing/ComunidadFloat';
import BitacoraPreview from '../components/landing/BitacoraPreview';
import CrowdfundingPreview from '../components/landing/CrowdfundingPreview';
// VentanaSala and NetworkExplainer preserved in src/components/landing/ but no longer used in landing
// import Network3DEmbed from '../components/Network3DEmbed'; // Red 3D desactivada — componente preservado en src/components/
import { useScrollReveal, revealStyle } from '../components/shared';

const C = {
  turquesa: '#5dc1b9',
  mango: '#FDBE02',
  coral: '#eb636b',
  morado: '#534AB7',
  logoGrad: 'linear-gradient(135deg, #534AB7, #1D9E75)',
  triGrad: 'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)',
  dark: '#0a0a0a',
  gray: '#555',
  lightGray: '#999',
  border: 'rgba(255,255,255,0.1)',
};
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";

const glassCard = {
  background: 'rgba(255,255,255,0.05)',
  backdropFilter: 'blur(30px)',
  WebkitBackdropFilter: 'blur(30px)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 24,
};
const glassHover = {
  border: '1px solid rgba(93,193,185,0.3)',
  boxShadow: '0 0 40px rgba(93,193,185,0.3)',
};

const btnStyle = {
  background: 'linear-gradient(135deg, #534AB7, #1D9E75, #534AB7)',
  color: '#fff',
  border: 'none',
  borderRadius: 50,
  fontFamily: font,
  cursor: 'pointer',
  fontWeight: 500,
  boxShadow: '0 0 40px rgba(93,193,185,0.4), 0 0 80px rgba(93,193,185,0.15)',
  transition: 'transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s, background 0.3s',
  backgroundSize: '200% auto',
  animation: 'shimmer 3s linear infinite',
};
const btnHoverEnter = e => {
  e.currentTarget.style.transform = 'translateY(-3px) scale(1.03)';
  e.currentTarget.style.boxShadow = '0 0 60px rgba(93,193,185,0.6), 0 0 120px rgba(93,193,185,0.25)';
};
const btnHoverLeave = e => {
  e.currentTarget.style.transform = 'translateY(0) scale(1)';
  e.currentTarget.style.boxShadow = '0 0 40px rgba(93,193,185,0.4), 0 0 80px rgba(93,193,185,0.15)';
};

/* Extracted: useScrollReveal, revealStyle → shared/useScrollReveal.js */
/* Extracted: ParticlesCanvas, FloatingBubbles, Bar, Faq, Card → components/landing/ */
/* Removed dead code: MemCard, ComparisonTable (moved to Membresias page) */

export default function Landing() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [authError, setAuthError] = useState(null);
  const { isMobile, isTablet } = useScreen();
  const t = useTheme();
  useTracker("landing", null);
  const { user, profile } = useAuth();
  const [scrollY, setScrollY] = useState(0);

  // Parallax scroll tracking
  useEffect(() => {
    if (isMobile) return;
    let ticking = false;
    const onScroll = () => {
      if (!ticking) { requestAnimationFrame(() => { setScrollY(window.scrollY); ticking = false; }); ticking = true; }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isMobile]);

  const handleBuy = (membership) => {
    if (!user) {
      localStorage.setItem('td_pending_checkout', membership);
      supabase.auth.signInWithOAuth({ provider: 'google', options: { redirectTo: window.location.origin + '/dashboard' } });
      return;
    }
    startCheckout(membership, user, profile);
  };

  /* realProjects fetch removed — VentanaSala is fully static */

  React.useEffect(() => {
    const hash = window.location.hash;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const hashParams = new URLSearchParams(hash.replace('#', '?'));
    const error = params.get('error') || hashParams.get('error');
    const desc = params.get('error_description') || hashParams.get('error_description') || '';
    const code = params.get('error_code') || hashParams.get('error_code') || '';
    if (error) {
      setAuthError({ error, desc, code, url: window.location.href });
    }
  }, []);

  const pad = isMobile ? '0 1rem' : '0 1.5rem';
  const cols1 = '1fr';
  const cols2 = 'repeat(2, minmax(0, 1fr))';
  const cols3 = 'repeat(3, minmax(0, 1fr))';
  const gridCols = isMobile ? cols1 : isTablet ? cols2 : cols3;
  const gridCols2 = isMobile ? cols1 : cols2;

  const handleLogin = async () => {
    const redirect = window.location.origin + '/dashboard';
    console.log('[Login] Starting PKCE OAuth, redirect:', redirect);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: redirect },
    });
    if (error) console.error('[Login] OAuth error:', error.message, error);
  };

  // Scroll reveal refs for each section
  const genioLucaReveal = useScrollReveal();
  const membresiasReveal = useScrollReveal();
  const radarReveal = useScrollReveal();
  const ctaReveal = useScrollReveal();

  return (
    <div style={{ fontFamily:font, color:'#fff', background:C.dark, minHeight:'100vh', overflowWrap:'break-word', wordWrap:'break-word', overflowX:'hidden' }}>
      {/* CustomCursor removed */}

      {/* NAV */}
      <nav style={{ maxWidth:940, margin:'0 auto', padding:isMobile?'1rem':'1.2rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:38, height:38, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#fff', fontSize:12, fontWeight:500 }}>T&D</span>
          </div>
          <span style={{ fontSize:16, fontWeight:500, color:'#fff' }}>Thinker & Doer</span>
        </div>
        {!isMobile && <span onClick={() => navigate('/nosotros')} style={{ fontSize:14, color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:font }}>Nosotros</span>}
        <button onClick={handleLogin} onMouseEnter={btnHoverEnter} onMouseLeave={btnHoverLeave} style={{ ...btnStyle, padding:'10px 28px', fontSize:14 }}>Entrar</button>
      </nav>

      {/* AUTH ERROR BANNER */}
      {authError && (
        <div style={{ maxWidth:940, margin:'0 auto', padding:'1rem 1.5rem' }}>
          <div style={{ ...glassCard, background:'rgba(235,99,107,0.15)', border:'1px solid rgba(235,99,107,0.3)', padding:'16px 20px' }}>
            <p style={{ fontSize:14, fontWeight:500, margin:'0 0 6px', color:'#ff8a8a' }}>Error al iniciar sesion</p>
            <p style={{ fontSize:12, color:'#ff8a8a', margin:'0 0 4px', wordBreak:'break-all' }}><strong>Error:</strong> {authError.error}</p>
            {authError.desc && <p style={{ fontSize:12, color:'#ff8a8a', margin:'0 0 4px', wordBreak:'break-all' }}><strong>Detalle:</strong> {authError.desc}</p>}
            {authError.code && <p style={{ fontSize:12, color:'#ff8a8a', margin:'0 0 4px' }}><strong>Codigo:</strong> {authError.code}</p>}
            <p style={{ fontSize:10, color:'rgba(255,138,138,0.7)', margin:'8px 0 0', wordBreak:'break-all' }}>{authError.url}</p>
            <button onClick={()=>{setAuthError(null);window.history.replaceState(null,'','/');}} style={{ marginTop:10, background:'rgba(235,99,107,0.3)', color:'#fff', border:'1px solid rgba(235,99,107,0.4)', borderRadius:50, padding:'8px 20px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font }}>Intentar de nuevo</button>
          </div>
        </div>
      )}

      {/* HERO — App preview del árbol + social proof */}
      <HeroArbol
        isMobile={isMobile}
        isTablet={isTablet}
        scrollY={scrollY}
        onStart={() => setShowModal(true)}
      />

      {/* RITUAL 4 — Lo actualizas / representas / acompañas / realizas */}
      <Ritual4 isMobile={isMobile} isTablet={isTablet} />

      {/* PASOS 5 — Lo que encuentras al entrar */}
      <Pasos5 isMobile={isMobile} isTablet={isTablet} />

      {/* SECCIÓN ÁRBOL — detalle + tabla de eras */}
      <SeccionArbol isMobile={isMobile} isTablet={isTablet} onStart={() => setShowModal(true)} />

      {/* SECCIÓN PROYECTOS — 3 cartas de emprendedores */}
      <SeccionProyectos isMobile={isMobile} isTablet={isTablet} onStart={() => setShowModal(true)} />

      {/* COMUNIDAD — tarjetas flotantes con fotos reales */}
      <ComunidadFloat isMobile={isMobile} />

      {/* BITÁCORA — preview de notas */}
      <BitacoraPreview isMobile={isMobile} isTablet={isTablet} />

      {/* GENIO & LUCA */}
      <section ref={genioLucaReveal.ref} style={{ maxWidth:940, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem', textAlign:'center', borderTop:`1px solid ${C.border}`, ...revealStyle(genioLucaReveal.inView) }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, justifyContent:'center', marginBottom:14 }}>
          <Bar/><p style={{ fontSize:isMobile?11:13, color:C.turquesa, fontWeight:500, letterSpacing:2, margin:0 }}>04 · CONOCE A TUS COMPAÑEROS</p>
        </div>
        <p style={{ fontSize:isMobile?18:24, fontWeight:400, marginBottom:8, fontFamily:serif, color:'#fff' }}>Te presentamos a tus 2 compañeros de este viaje</p>
        <p style={{ fontSize:isMobile?13:14, color:'rgba(255,255,255,0.5)', marginBottom:isMobile?20:32 }}>Dos personalidades. Un solo objetivo: que crezcas.</p>
        <div style={{ display:'grid', gridTemplateColumns:gridCols2, gap:isMobile?12:18 }}>
          <Card borderTopColor={C.mango} style={{ textAlign:'left' }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
              <div style={{ width:52, height:52, borderRadius:'50%', background:'linear-gradient(135deg, #FDBE02, #eb636b, #5dc1b9)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 6px 20px rgba(253,190,2,0.25)', fontSize:22 }}>⚡</div>
              <div>
                <p style={{ fontSize:18, fontWeight:500, margin:0, color:'#fff' }}>Genio</p>
                <p style={{ fontSize:13, color:C.mango, fontWeight:500, margin:0 }}>El Thinker</p>
              </div>
            </div>
            <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', lineHeight:1.8, marginBottom:16 }}>Bromista, elocuente, aventado, noble. Te lanza ideas que no se te hubieran ocurrido y te dice "sí se puede" cuando sientes que no.</p>
            <div style={{ background:'rgba(253,190,2,0.08)', borderRadius:14, padding:'14px 16px', borderLeft:`3px solid ${C.mango}` }}>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.6, fontStyle:'italic', margin:0 }}>"¡¿Y POR QUÉ NO LOS DOS?! Imagínate: Postres que saben a pecado pero son un ángel. ¿No está brutal?"</p>
            </div>
          </Card>
          <Card borderTopColor={C.turquesa} style={{ textAlign:'left' }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
              <div style={{ width:52, height:52, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 6px 20px rgba(93,193,185,0.25)', fontSize:22 }}>◆</div>
              <div>
                <p style={{ fontSize:18, fontWeight:500, margin:0, color:'#fff' }}>Luca</p>
                <p style={{ fontSize:13, color:C.turquesa, fontWeight:500, margin:0 }}>La Doer</p>
              </div>
            </div>
            <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', lineHeight:1.8, marginBottom:16 }}>"Todo muy bonito pero hay que trabajar." Directa, sabia, te da los pasos concretos. Tu compañera que te aterriza.</p>
            <div style={{ background:'rgba(93,193,185,0.08)', borderRadius:14, padding:'14px 16px', borderLeft:`3px solid ${C.turquesa}` }}>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.6, fontStyle:'italic', margin:0 }}>"Escúchame: si le vendes a todos, no le vendes a nadie. Llena la plantilla y hazlo hoy, no mañana."</p>
            </div>
          </Card>
        </div>
      </section>

      {/* TU RADAR — sección 05 */}
      <section ref={radarReveal.ref} style={{ maxWidth:600, margin:'0 auto', padding:isMobile?'1.5rem 1rem':'2.5rem 1.5rem', borderTop:`1px solid ${C.border}`, textAlign:'center', ...revealStyle(radarReveal.inView) }}>
        <p style={{ fontSize:isMobile?11:12, letterSpacing:3, fontWeight:700, textTransform:'uppercase', color:C.coral, margin:'0 0 14px' }}>05 · ¿No sabes por dónde empezar?</p>
        <h2 style={{ fontFamily:serif, fontSize:isMobile?24:isTablet?36:42, fontWeight:400, lineHeight:1, margin:'0 0 16px', color:'#fff' }}>Radar: 31 formas reales de generar ingresos <em style={{ color:C.coral, fontStyle:'italic' }}>y cuál es para ti.</em></h2>
        <p style={{ fontSize:isMobile?13:14, color:'rgba(255,255,255,0.5)', margin:'0 0 20px' }}>Un solo pago, sin suscripcion.</p>
      </section>
      <section id="radar" style={{ maxWidth:600, margin:'0 auto', padding:isMobile?'0 1rem 1.5rem':'0 1.5rem 2.5rem' }}>
        <div style={{ ...glassCard, padding:isMobile?'2rem 1.5rem':'2.5rem', textAlign:'center', position:'relative', overflow:'hidden', animation:'iriBorder 6s ease infinite' }}>
          <p style={{ fontSize:48, margin:'0 0 8px' }}>📡</p>
          <p style={{ fontFamily:serif, fontSize:isMobile?24:28, fontWeight:400, margin:'0 0 6px', color:'#fff' }}>Tu Radar</p>
          <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', fontStyle:'italic', margin:'0 0 16px' }}>31 caminos. 30 días para explorarlos. 1 que será el tuyo.</p>
          <p style={{ fontSize:isMobile?28:36, fontWeight:600, margin:'0 0 4px', background:C.logoGrad, WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text' }}>$599 MXN</p>
          <p style={{ fontSize:12, color:'rgba(255,255,255,0.4)', margin:'0 0 20px' }}>Pago único · acceso de por vida</p>
          <p style={{ fontSize:14, color:'rgba(255,255,255,0.7)', lineHeight:1.7, margin:'0 0 20px', textAlign:'left' }}>No te decimos qué emprender. Te mostramos las 31 formas reales de ganar dinero en internet y te ayudamos a descubrir cuál es para ti.</p>
          <div style={{ textAlign:'left', display:'flex', flexDirection:'column', gap:8, marginBottom:24 }}>
            {['Test de personalidad + radar de habilidades','31 formas reales con casos de LatAm','5 videos exclusivos de Bruno','Genio & Luca te acompañan 30 días','Decides tu camino con datos, no con intuición'].map((item, i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:8, fontSize:14 }}>
                <span style={{ color:C.turquesa, fontWeight:700 }}>✓</span>
                <span style={{ color:'rgba(255,255,255,0.7)' }}>{item}</span>
              </div>
            ))}
          </div>
          <button onClick={()=>handleBuy('tu_radar')} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'14px 36px', fontSize:15, fontWeight:500, cursor:'pointer', fontFamily:font }}>Quiero mi Radar →</button>
          <p style={{ fontSize:11, color:'rgba(255,255,255,0.4)', margin:'12px 0 0' }}>Garantía 14 días. Si no te convence, reembolso 100%.</p>
          <p style={{ fontSize:10, color:'rgba(255,255,255,0.3)', margin:'8px 0 0' }}>Al comprar aceptas nuestros <a href="/terminos" style={{ color:'rgba(255,255,255,0.45)', textDecoration:'underline' }}>Términos</a> y <a href="/privacidad" style={{ color:'rgba(255,255,255,0.45)', textDecoration:'underline' }}>Aviso de privacidad</a>.</p>
        </div>
      </section>

      {/* CROWDFUNDING · PRÓXIMAMENTE */}
      <CrowdfundingPreview isMobile={isMobile} />

      {/* PLANES — Free Observer / Doer */}
      <section ref={membresiasReveal.ref} id="planes" style={{ maxWidth:940, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem', textAlign:'center', borderTop:`1px solid ${C.border}`, ...revealStyle(membresiasReveal.inView) }}>
        <p style={{ fontSize:isMobile?11:12, letterSpacing:3, fontWeight:700, textTransform:'uppercase', color:'rgba(255,255,255,0.4)', margin:'0 0 14px' }}>Empieza gratis · un solo plan premium</p>
        <h2 style={{ fontFamily:serif, fontSize:isMobile?24:isTablet?36:48, fontWeight:400, lineHeight:1, margin:'0 auto 28px', maxWidth:860, color:'#fff' }}>
          Gratis te damos el mapa y tus dos primeras victorias.{' '}
          <em style={{ background:`linear-gradient(90deg, ${C.turquesa}, ${C.mango}, ${C.coral})`, WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', fontStyle:'italic' }}>Premium es todo lo que sigue.</em>
        </h2>

        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:20, textAlign:'left', maxWidth:760, margin:'0 auto' }}>
          {/* Free Observer */}
          <div style={{ background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:20, padding:28, display:'flex', flexDirection:'column', gap:10 }}>
            <span style={{ fontSize:11, letterSpacing:2, fontWeight:700, color:'rgba(255,255,255,0.4)' }}>GRATIS · PARA SIEMPRE</span>
            <span style={{ fontFamily:serif, fontSize:34, lineHeight:1, color:'#fff' }}>Free Observer</span>
            <span style={{ fontSize:26, fontWeight:800, color:'#fff' }}>$0</span>
            <ul style={{ margin:0, padding:0, listStyle:'none', color:'rgba(255,255,255,0.55)', fontSize:14 }}>
              {['Árbol completo: ve y llena todas las misiones','Vence los dos primeros jefes: Raíz y Mundo 01','Tu carta de negocio pública','Ver las cartas de la comunidad','Bitácora privada (15 notas)','Genio y Luca con cupo semanal'].map((f,i) => (
                <li key={i} style={{ margin:'4px 0' }}>✓ {f}</li>
              ))}
            </ul>
            <button onClick={()=>setShowModal(true)} style={{ marginTop:8, background:'transparent', border:`1px solid ${C.border}`, borderRadius:999, padding:'0 22px', height:46, fontWeight:700, fontSize:15, color:'#fff', cursor:'pointer', fontFamily:font }}>Empezar gratis</button>
          </div>

          {/* Doer — premium */}
          <div style={{ background:'rgba(255,255,255,0.04)', border:`1px solid ${C.turquesa}`, borderRadius:20, padding:28, display:'flex', flexDirection:'column', gap:10, boxShadow:'0 0 50px rgba(93,193,185,0.12)' }}>
            <span style={{ fontSize:11, letterSpacing:2, fontWeight:700, color:C.turquesa }}>PREMIUM · EL ÚNICO PLAN</span>
            <span style={{ fontFamily:serif, fontSize:34, lineHeight:1, color:'#fff' }}>Doer</span>
            <span style={{ fontSize:26, fontWeight:800, color:'#fff' }}>$139 <small style={{ fontSize:14, color:'rgba(255,255,255,0.4)', fontWeight:500 }}>MXN / mes</small></span>
            <ul style={{ margin:0, padding:0, listStyle:'none', color:'rgba(255,255,255,0.55)', fontSize:14 }}>
              {['Todo lo gratis','Vence todos los jefes: del Mundo 02 a Madurez','Luca revisa tu evidencia y audita tu expediente','OKR trimestral y reportes de avance','Comparte tus aprendizajes y haz match en la red','Genio y Luca sin límite, con contexto de tu árbol','Bitácora ilimitada conectada a Mis Ideas','Elegible para el crowdfunding'].map((f,i) => (
                <li key={i} style={{ margin:'4px 0' }}>✓ {f}</li>
              ))}
            </ul>
            <button onClick={()=>handleBuy('doer')} onMouseEnter={btnHoverEnter} onMouseLeave={btnHoverLeave} style={{ ...btnStyle, marginTop:8, padding:'0 22px', height:46, fontSize:15 }}>Probar 7 días al vencer el Mundo 01</button>
          </div>
        </div>

        <p style={{ margin:'22px auto 0', maxWidth:620, fontSize:13, color:'rgba(255,255,255,0.4)' }}>La prueba premium no empieza al registrarte: empieza cuando ganas tu primera insignia. Primero ganas, luego decides.</p>
        <p style={{ margin:'12px auto 0', fontSize:14 }}>
          <a href="#radar" style={{ color:C.turquesa, textDecoration:'none', fontWeight:500 }}>¿Aún no tienes negocio? Empieza con Tu Radar →</a>
        </p>
        <p style={{ margin:'16px auto 0', fontSize:13 }}>
          <span onClick={() => navigate('/preguntas-frecuentes')} style={{ color:'rgba(255,255,255,0.4)', cursor:'pointer', textDecoration:'underline', textDecorationStyle:'dotted', textUnderlineOffset:4 }}>¿Tienes dudas? Resolvemos las más comunes →</span>
        </p>
      </section>

      {/* CTA */}
      <section ref={ctaReveal.ref} style={{ maxWidth:940, margin:'0 auto', padding:isMobile?'1rem':'1rem 1.5rem 2.5rem', ...revealStyle(ctaReveal.inView) }}>
        <div className="td-cta-bg" style={{ ...glassCard, borderRadius:isMobile?16:24, padding:isMobile?'2rem 1rem':'3rem 1.5rem', textAlign:'center', position:'relative', overflow:'hidden' }}>
          <p style={{ fontSize:isMobile?20:26, fontWeight:400, marginBottom:10, fontFamily:serif, color:'#fff', position:'relative', zIndex:1 }}>¿Listo para subir de nivel?</p>
          <p style={{ fontSize:isMobile?13:15, color:'rgba(255,255,255,0.5)', marginBottom:24, position:'relative', zIndex:1 }}>Crea tu jugador en un minuto, arma tu árbol y empieza por la misión que ya tienes resuelta.</p>
          <button onClick={() => setShowModal(true)} onMouseEnter={btnHoverEnter} onMouseLeave={btnHoverLeave} className="td-pulse-btn td-iri-btn" style={{ ...btnStyle, padding:'15px 40px', fontSize:16, position:'relative', zIndex:1 }}>Empieza gratis</button>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ maxWidth:940, margin:'0 auto', padding:'2rem 1.5rem', textAlign:'center', borderTop:'1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginBottom:8 }}>
          <div style={{ width:26, height:26, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#fff', fontSize:9, fontWeight:500 }}>T&D</span>
          </div>
          <span style={{ fontSize:13, fontWeight:500, color:'rgba(255,255,255,0.6)' }}>Thinker & Doer</span>
        </div>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.4)', margin:'0 0 16px' }}>Crecer juntos, sin competir. Cada quien a su ritmo y ruta.</p>
        <div style={{ display:'flex', justifyContent:'center', gap:16, marginBottom:12 }}>
          {/* Social media placeholder icons */}
          {['Instagram','TikTok','LinkedIn','YouTube'].map((name, i) => (
            <a key={i} href="#" style={{ width:36, height:36, borderRadius:'50%', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center', textDecoration:'none', color:'rgba(255,255,255,0.5)', fontSize:10, fontWeight:500, transition:'border 0.3s, color 0.3s' }}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(93,193,185,0.4)';e.currentTarget.style.color=C.turquesa;}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(255,255,255,0.1)';e.currentTarget.style.color='rgba(255,255,255,0.5)';}}
            >{name[0]}</a>
          ))}
        </div>
        <div style={{ display:'flex', justifyContent:'center', gap:20, flexWrap:'wrap' }}>
          {[{label:'Términos',href:'/terminos'},{label:'Privacidad',href:'/privacidad'},{label:'Contacto',href:'mailto:thinkanddo.er@gmail.com'}].map((link, i) => (
            <a key={i} href={link.href} style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none', transition:'color 0.3s' }}
              onMouseEnter={e=>e.currentTarget.style.color='rgba(255,255,255,0.7)'}
              onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.35)'}
            >{link.label}</a>
          ))}
        </div>
      </footer>

      {/* MODAL — portal to body to escape transform/filter ancestors */}
      {showModal && createPortal(
        <>
          {/* Overlay — no backdrop-filter to avoid containing block */}
          <div onClick={() => setShowModal(false)} style={{
            position:'fixed', top:0, left:0, width:'100vw', height:'100vh',
            background:'rgba(0,0,0,0.8)',
            zIndex:99998,
          }} />
          {/* Modal card — separate fixed element */}
          <div style={{
            position:'fixed', top:0, left:0, width:'100vw', height:'100vh',
            display:'flex', alignItems:'center', justifyContent:'center',
            zIndex:99999, pointerEvents:'none',
          }}>
            <div onClick={e => e.stopPropagation()} style={{
              background:'rgba(20,20,30,0.95)',
              border:'1px solid rgba(255,255,255,0.15)', borderRadius:24,
              padding:'3rem 2.5rem',
              maxWidth:440, width:'90%', textAlign:'center',
              fontFamily:font, pointerEvents:'auto',
              boxShadow:'0 20px 60px rgba(0,0,0,0.5)',
            }}>
              <div style={{ width:48, height:48, borderRadius:'50%', background:C.logoGrad, margin:'0 auto 20px', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <span style={{ color:'#fff', fontSize:14, fontWeight:600 }}>T&D</span>
              </div>
              <p style={{ fontSize:20, fontWeight:400, fontFamily:serif, margin:'0 0 10px', color:'#fff' }}>
                Estás por observar la comunidad más grande de proyectos en Latinoamérica
              </p>
              <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:'0 0 28px' }}>
                Aquí ayudamos, innovamos y crecemos juntos. Te damos la bienvenida a que observes cómo trabajamos.
              </p>
              <button onClick={handleLogin} style={{
                background:'linear-gradient(135deg, #534AB7, #1D9E75)',
                color:'#fff', border:'none', borderRadius:50, fontFamily:font,
                cursor:'pointer', fontWeight:500, padding:'14px 40px', fontSize:16,
              }}>
                Entrar
              </button>
            </div>
          </div>
        </>,
        document.body
      )}

      <style>{`
        @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
        @keyframes modalFadeIn { from { opacity:0 } to { opacity:1 } }
        @keyframes modalSlideUp { from { opacity:0; transform:translateY(20px) } to { opacity:1; transform:translateY(0) } }

        @keyframes iridescent {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .td-gradient-text {
          background: linear-gradient(90deg, #5dc1b9, #FDBE02, #eb636b, #534AB7, #1D9E75, #5dc1b9);
          background-size: 300% 300%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: iridescent 4s ease infinite;
          cursor: pointer;
        }
        .td-gradient-text:hover {
          animation-duration: 1.5s;
        }
        .td-iridescent {
          background: linear-gradient(90deg, #5dc1b9, #FDBE02, #eb636b, #534AB7, #1D9E75, #5dc1b9);
          background-size: 300% 300%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: iridescent 4s ease infinite;
          cursor: pointer;
        }
        @keyframes iriGlow {
          0% { box-shadow: 0 0 30px rgba(93,193,185,0.4), 0 0 60px rgba(93,193,185,0.15); }
          33% { box-shadow: 0 0 30px rgba(253,190,2,0.4), 0 0 60px rgba(253,190,2,0.15); }
          66% { box-shadow: 0 0 30px rgba(235,99,107,0.4), 0 0 60px rgba(235,99,107,0.15); }
          100% { box-shadow: 0 0 30px rgba(93,193,185,0.4), 0 0 60px rgba(93,193,185,0.15); }
        }
        @keyframes iriBorder {
          0% { border-color: rgba(93,193,185,0.4); }
          25% { border-color: rgba(253,190,2,0.4); }
          50% { border-color: rgba(235,99,107,0.4); }
          75% { border-color: rgba(83,74,183,0.4); }
          100% { border-color: rgba(93,193,185,0.4); }
        }
        .glass-card:hover { animation: iriBorder 3s ease infinite; }

        .onsite-scroll { scrollbar-width: thin; scrollbar-color: rgba(93,193,185,0.3) transparent; }
        .onsite-scroll::-webkit-scrollbar { height: 6px; }
        .onsite-scroll::-webkit-scrollbar-track { background: transparent; }
        .onsite-scroll::-webkit-scrollbar-thumb { background: linear-gradient(90deg, #5dc1b9, #534AB7, #FDBE02); border-radius: 3px; }
        .td-iri-btn { animation: iriGlow 3s ease infinite; }
        @keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }

        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 20px rgba(93,193,185,0.3), 0 4px 15px rgba(83,74,183,0.2); }
          50% { box-shadow: 0 0 40px rgba(93,193,185,0.5), 0 4px 15px rgba(83,74,183,0.2); }
        }
        .td-pulse-btn {
          animation: pulse 2.5s ease-in-out infinite;
        }

        @keyframes ctaGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .td-cta-bg::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(270deg, rgba(93,193,185,0.1), rgba(253,190,2,0.08), rgba(235,99,107,0.1), rgba(93,193,185,0.1));
          background-size: 300% 300%;
          animation: ctaGradient 8s ease infinite;
          border-radius: inherit;
          z-index: 0;
        }

        /* brujula animations removed — Tu Radar uses iriBorder */

        .td-journey-connector {
          background: linear-gradient(180deg, #5dc1b9, #FDBE02, #eb636b);
          background-size: 100% 200%;
          animation: gradientShift 4s ease infinite;
        }

        @media (min-width: 768px) {
          /* cursor: none removed — using system cursor */
        }

        .glass-card { position: relative; overflow: hidden; }
        .glass-card::after { content: ''; position: absolute; top: -50%; left: -50%; width: 200%; height: 200%; background: linear-gradient(45deg, transparent 40%, rgba(255,255,255,0.03) 50%, transparent 60%); transform: translateX(-100%); transition: transform 0.6s; pointer-events: none; }
        .glass-card:hover::after { transform: translateX(100%); }

        @media (prefers-reduced-motion: reduce) {
          .td-gradient-text,
          .td-iridescent,
          .td-pulse-btn,
          .td-iri-btn,
          .td-cta-bg::before,
          /* .td-brujula-card removed */
          .td-journey-connector,
          .glass-card {
            animation: none !important;
          }
          .td-gradient-text {
            background: linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b);
            background-size: 100% 100%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
        }
      `}</style>
    </div>
  );
}
